import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { formDataToData } from 'app/utils/app/requests'
import { api } from 'app/utils/constants'

export const create = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.products.import.CREATE}`,
    async ({ request }) => {
        const data = await request.formData()
        const dataJson = formDataToData(data)

        // Wrong data
        if (!data) {
            return new HttpResponse(null, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json(dataJson, {
            status: StatusCodes.CREATED,
        })
    },
)
